import checkTracker from '../../check-tracker/store';
import pagination from '../bootstrap/pagination/pagination-store';

const initialState = {
    columns: [],
    rows: [],
    sortBy: undefined,
    selectable: true,
    responsive: false, // responsive in bootstrap means horizontally scrollable table
};

export default {
    namespaced: true,
    state: () => Object.assign({}, initialState),
    mutations: {
        setRows(state, rows) {
            state.rows = rows;
        },
        setColumns(state, columns) {
            state.columns = columns;
        },
        setSelectable(state, selectable) {
            state.selectable = selectable;
        },
        setResponsive(state, responsive) {
            state.responsive = responsive;
        },
        setColumnAttr(state, [key, attr, value]) {
            const column = state.columns.find(column => column.key === key);
            column[attr] = value;
        },
        reset(state) {
            Object.assign({}, initialState);
        },
    },
    modules: {
        checkTracker,
        pagination
    },
};
